import {memo} from 'react'
import {LinkButtonProps} from './types'
import {Link, RouterLink} from '../link'
import clsx from 'clsx'
import * as classes from './LinkButton.classes'
import {Button} from '../button'

const LinkButton = memo(function LinkButton({className, ...props}: LinkButtonProps<typeof Link>) {
  return <Button Component={Link} {...props} className={clsx(classes.linkButton, className)} />
})

export const RouterLinkButton = memo(function RouterLinkButton({
  className,
  ...props
}: LinkButtonProps<typeof RouterLink>) {
  return <Button Component={RouterLink} {...props} className={clsx(classes.linkButton, className)} />
})

export default LinkButton
